import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import React from 'react'

import { cn } from '@/lib/cn'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'border-system-border-primary text-system-text-primary z-50 rounded-sm border bg-white px-3 py-2 text-sm shadow-sm animate-in fade-in-0 zoom-in-95  data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 select-none leading-none will-change-[transform]',
      className,
    )}
    {...props}
  >
    {props.children}
    <TooltipPrimitive.Arrow
      className="h-2 w-3 fill-white stroke-system-border-primary"
      style={{
        strokeDasharray: '0 30 30',
        strokeWidth: 2,
      }}
    />
  </TooltipPrimitive.Content>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
